import React, { useEffect, useState } from "react";
import CustomSearch from "../../CustomSearch/CustomSearch";
import useCorsi from "../../../hooks/useCorsi";
import DatePicker, { registerLocale } from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import it from 'date-fns/locale/it';
import { useSelector } from "react-redux";
import { ROLES } from "../../../model/roles";
import { Spinner } from "react-bootstrap";
import UtilityService from "../../../services/UtillityServices/UtilityService";
import useSedi from "../../../hooks/useSedi";

registerLocale('it', it);

export default function ClasseManagerForm({
  formClasseManager,
  setFormClasseManager,
  showModalClasseManager,
  isUpdateMode = false
}) {
  const { getCorsiByParams } = useCorsi();
  const { getSediByParams } = useSedi();
  const [selectedCorso, setSelectedCorso] = useState(null);
  const [selectedSede, setSelectedSede] = useState(null);
  const [corsi, setCorsi] = useState([]);
  const userLoggedIn = useSelector(state => state?.user?.userData);
  const [isLoadingCorso, setIsLoadingCorso] = useState(false);

  useEffect(() => {
    if (!showModalClasseManager) {
      setFormClasseManager({});
      setSelectedCorso(null);
      setSelectedSede(null);
    }

    if(userLoggedIn?.role === ROLES.COURSE_DESIGNER || userLoggedIn?.role === ROLES.DOCENTE) {
      fetchCorsi();
    }
  }, [showModalClasseManager]);

  useEffect(() => {
    if (selectedCorso && !isUpdateMode) {
      
      setFormClasseManager(prevState => ({
        ...prevState,
        corso: selectedCorso,
        id_sede: selectedSede?.id_sede
      }));
    }
  }, [selectedCorso, isUpdateMode, selectedSede]);

  const fetchCorsi = async () => {
    setIsLoadingCorso(true);
    const corsi = await getCorsiByParams({});
    setCorsi(corsi?.data || []);
    setIsLoadingCorso(false);
  };

  const handleDateChange = (date, field) => {
    setFormClasseManager(prevState => ({ ...prevState, [field]: date }));
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormClasseManager(prevState => ({ ...prevState, [name]: value }));
  };

  const customSearchApi = async (params) => {
    const combinedParams = {
      ...params,
      filtri: {
        ...params.filtri,
        modalita_erogazione: ["Presenza", "Telematica_Sincrona", "Telematica_Mista", "Mista_Presenza/Telematica"]
      }
    };
    return getCorsiByParams(combinedParams);
  };

  const handleCorsoSelect = (e) => {
    const selectedId = e.target.value;
    if (selectedId === "") {
      setSelectedCorso(null);
      setSelectedSede(null);
      setFormClasseManager(prevState => ({
        ...prevState,
        id_corso: null,
        id_sede: null,
        data_inizio: null,
        data_fine: null
      }));
    } else {
      const corso = corsi.find(c => c.id_corso === parseInt(selectedId));
      setSelectedCorso(corso);
    }
  };


  if(isLoadingCorso) {
    return <div className='m-auto text-center'>
              <p>Caricando I corsi...</p>
              <Spinner animation="border" role="status">
                <span className="visually-hidden">Caricamento...</span>
             </Spinner>
           </div>
  }

  if (isUpdateMode) {
    return (
      <div className="container">
        <div className='row'>
          <div className='col-sm-12 my-2'>
            <span className='small text-muted d-block mb-1'><b>Nome</b></span>
            <input 
              name="denominazione" 
              value={formClasseManager.denominazione || ''} 
              onChange={handleInputChange} 
              className="form-control" 
              type="text" 
              placeholder="Nome"
            />
          </div>
        </div>
      </div>
    );
  }

  return (
    <>
      <div className="container">
        <div className='row'>
          <div className='col-sm-12 my-2'>
            <span className='small text-muted d-block mb-1'><b>Nome</b></span>
            <input name="denominazione" value={formClasseManager.denominazione || ''} onChange={handleInputChange} className="form-control" type="text" placeholder="Nome"/>
          </div>
          <div className='col-sm-12 my-2'>
            {userLoggedIn?.role === ROLES.ADMIN && (
              <>
              <CustomSearch
                field={"denominazione"}
                label={"Cerca corso"}
                searchApi={customSearchApi}
                placeholder={"Nome del corso"}
                selectedItem={selectedCorso}
                setSelectedItem={setSelectedCorso}
              />

              </>
            )}
            {(userLoggedIn?.role === ROLES.COURSE_DESIGNER || userLoggedIn?.role === ROLES.DOCENTE) && (
              <div>
                <span className='small text-muted d-block mb-1'><b>Seleziona corso</b></span>
                <select 
                  className="form-select" 
                  onChange={handleCorsoSelect}
                  value={selectedCorso?.id_corso || ''}
                >
                  <option value="">Seleziona un corso</option>
                  {corsi.map(corso => (
                    <option key={corso.id_corso} value={corso.id_corso}>
                      {corso.denominazione}
                    </option>
                  ))}
                </select>
              </div>
            )}
          </div>
        </div>
        {selectedCorso && (
        <div className="row">
          <div className="col-sm-6">
            <span className="small text-muted d-block mb-1">
              <b>Data inizio</b>
            </span>
            <DatePicker
              selected={formClasseManager.data_inizio || null}
              onChange={(date) => handleDateChange(date, 'data_inizio')}
              dateFormat="dd/MM/yyyy"
              className="form-control"
              locale="it"
              placeholderText="Seleziona data inizio"
              maxDate={formClasseManager.data_fine || null}
              minDate={new Date()}
            />
          </div>
          <div className="col-sm-6">
            <span className="small text-muted d-block mb-1">
              <b>Data fine</b>
            </span>
            <DatePicker
              selected={formClasseManager.data_fine || null}
              onChange={(date) => handleDateChange(date, 'data_fine')}
              dateFormat="dd/MM/yyyy"
              className="form-control"
              locale="it"
              placeholderText="Seleziona data fine"
              minDate={formClasseManager.data_inizio || new Date()}
            />
          </div>
          {
            (selectedCorso.modalita_erogazione === "Presenza" || selectedCorso.modalita_erogazione === "Mista_Presenza/Telematica") && (
              <div className="col-sm-12 my-2">
              <CustomSearch
                field={"descrizione"}
                label={"Cerca sede"}
                searchApi={getSediByParams}
                placeholder={"Nome della sede"}
                selectedItem={selectedSede}
                setSelectedItem={setSelectedSede}
              />
              </div>
            )
          }
          {
             selectedCorso && (
               <div className="col-sm-12 mt-3">
                 <span className="small text-muted d-block"><b>Corso selezionato:</b> {selectedCorso.denominazione}</span>
                 <span className="small text-muted d-block"><b>Modalità di erogazione:</b> {UtilityService.getModalitaErogazione(selectedCorso.modalita_erogazione)}</span>
                 {
                   selectedSede && (
                     <span className="small text-muted d-block"><b>Sede selezionata:</b> {selectedSede.descrizione}</span>
                   )
                 }
               </div>
             )
           }
        </div>
        )}
      </div>
    </>
  );
}
